export default class {
    /* eslint class-methods-use-this: 0 */
    logMessage(msg, context) {
        if (Raven && typeof Raven.captureMessage === 'function') {
            Raven.captureMessage(msg, { extra: context });
        }
    }

    logEditProfileMessage(msg, xhr, state) {
        const data = JSON.parse(JSON.stringify(state));

        data.images = [];
        state.spaces.forEach(space => {
            space.images = [];
        });

        this.logMessage(msg, {
            status: xhr.status,
            data: data,
        });
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/tracker.jsx